interface IconProps {
  white?: boolean
  black?: boolean
  className?: string
}

export const IconIWC = () => (
  <svg fill="none" height="64" viewBox="0 0 65 64" width="65" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="31.4563" cy="27.0279" fill="#ec0000" rx="11.3929" ry="11.3929" />
    <path
      d="m47.573 12.0318c-.6137-.6137-1.6087-.6137-2.2224 0l-3.3335 3.3335c-.6137.6137-.6137 1.6086 0 2.2223l1.5048 1.5048c.0865.0865.1631.1829.2259.2878 3.3426 5.5833 2.6087 12.9266-2.2018 17.7371-4.8108 4.8108-12.1547 5.5445-17.7382 2.2012-.1049-.0628-.2012-.1394-.2877-.2258l-1.504-1.5041c-.6137-.6136-1.6086-.6136-2.2223 0l-3.3335 3.3336c-.6137.6136-.6137 1.6086 0 2.2223l.5556.5556c.6136.6136 1.6086.6136 2.2223 0l.6895-.6896c.5349-.5349 1.372-.6058 2.0249-.2239 2.5744 1.506 5.4352 2.3361 8.3253 2.4903v2.5723h-7.8571c-.8679 0-1.5715.7035-1.5715 1.5714v.7857c0 .8679.7036 1.5715 1.5715 1.5715h19.6428c.8679 0 1.5715-.7036 1.5715-1.5715v-.7857c0-.8679-.7036-1.5714-1.5715-1.5714h-7.8571v-2.7799c3.7041-.594 7.262-2.3187 10.1174-5.1741 6.0649-6.0648 7.0287-15.2991 2.8914-22.3713-.382-.6529-.311-1.49.2239-2.0249l.6893-.6893c.6137-.6137.6137-1.6086 0-2.2223z"
      fill="#ec0000"
    />
    <rect height="63" rx="31.5" stroke="#f9d6dc" width="63" x="1" y=".5" />
  </svg>
)

export const IconP = () => (
  <svg fill="none" height="64" viewBox="0 0 65 64" width="65" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ff5afe">
      <path d="m29.9287 28.5713h4.28571v11.1429h-4.28571z" />
      <rect height="11.1429" rx="3" width="31.7143" x="16.2144" y="38.8572" />
      <path d="m20.5 38.2856c0-1.1045.8954-2 2-2h1.1429c1.1045 0 2 .8955 2 2v.5715h-5.1429z" />
      <path
        clipRule="evenodd"
        d="m32.0716 29.4285c4.4971 0 8.1428-3.6456 8.1428-8.1428s-3.6457-8.1429-8.1428-8.1429c-4.4972 0-8.1429 3.6457-8.1429 8.1429s3.6457 8.1428 8.1429 8.1428zm-2.1429-9.4285c.9468 0 1.7143-.7675 1.7143-1.7143s-.7675-1.7143-1.7143-1.7143-1.7143.7675-1.7143 1.7143.7675 1.7143 1.7143 1.7143z"
        fillRule="evenodd"
      />
    </g>
    <rect height="63" rx="31.5" stroke="#f2d3f2" width="63" x="1" y=".5" />
  </svg>
)

export const IconCU = () => (
  <svg fill="none" height="64" viewBox="0 0 65 64" width="65" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="m40.396 44.9162c-1.8845 4.1694-4.6378 6.798-7.7047 6.798-3.0668 0-5.8202-2.6286-7.7047-6.798-4.553.4527-8.2061-.6175-9.7395-3.2735-1.5335-2.6559-.6338-6.3547 2.0348-10.0714-2.6686-3.7167-3.5683-7.4155-2.0348-10.0714 1.5334-2.656 5.1865-3.7262 9.7395-3.2735 1.8845-4.1694 4.6379-6.7979 7.7047-6.7979 3.0669 0 5.8202 2.6285 7.7047 6.7979 4.553-.4527 8.2061.6175 9.7395 3.2735 1.5334 2.6559.6337 6.3547-2.0349 10.0714 2.6686 3.7167 3.5683 7.4155 2.0349 10.0714-1.5334 2.656-5.1864 3.7262-9.7395 3.2735zm-2.2102-3.8281c.1009-.3208.1971-.6498.2883-.9865-.2112.1272-.4246.253-.64.3774-.2153.1243-.431.2462-.6467.3655.3372.0893.6702.1705.9984.2436zm-1.3005 3.2172c-1.3608-.3316-2.7674-.7783-4.194-1.3389-1.4266.5606-2.8332 1.0073-4.1939 1.3388 1.6534 3.2124 3.3185 3.9804 4.1939 3.9804s2.5405-.768 4.194-3.9803zm-8.6901-3.4608c-.3372.0893-.6702.1705-.9984.2436-.1008-.3208-.197-.6498-.2883-.9865.2112.1272.4246.253.6399.3774.2154.1243.431.2462.6468.3655zm-5.3723-3.5756c.2278 1.5158.5442 2.9572.9375 4.3014-3.6088.1743-5.1064-.8837-5.5441-1.6419-.4377-.7581-.6052-2.5841 1.3501-5.6222.9675 1.0127 2.0576 2.0075 3.2565 2.9627zm3.2162-1.8569c.9965.7292 2.0731 1.4335 3.2236 2.0978 1.1505.6642 2.2988 1.2445 3.4286 1.7428 1.1298-.4983 2.2781-1.0786 3.4286-1.7428 1.1505-.6643 2.2271-1.3686 3.2236-2.0979.1333-1.2276.205-2.5121.205-3.8406 0-1.3284-.0717-2.613-.205-3.8406-.9965-.7293-2.0731-1.4336-3.2236-2.0979-1.1505-.6642-2.2988-1.2445-3.4286-1.7428-1.1298.4983-2.2781 1.0786-3.4286 1.7428-1.1505.6643-2.2271 1.3686-3.2236 2.0978-.1333 1.2277-.2049 2.5122-.2049 3.8407s.0716 2.6131.2049 3.8407zm11.1483-13.1139c.2157.1193.4314.2412.6467.3655.2154.1244.4288.2502.64.3774-.0912-.3367-.1874-.6657-.2883-.9865-.3282.0731-.6612.1543-.9984.2436zm5.7828 8.5304c.0045.2465.0068.4941.0068.7428s-.0023.4963-.0068.7428c.2459-.2473.4827-.4951.7101-.7428-.2274-.2477-.4642-.4955-.7101-.7428zm2.846-1.9921c-.9675-1.0127-2.0576-2.0074-3.2564-2.9626-.2278-1.5158-.5443-2.9573-.9375-4.3015 3.6086-.1743 5.1063.8837 5.544 1.6419.4377.7581.6052 2.5841-1.3501 5.6222zm0 5.4698c-.9675 1.0127-2.0576 2.0074-3.2564 2.9626-.2278 1.5158-.5443 2.9573-.9375 4.3015 3.6086.1743 5.1063-.8837 5.544-1.6419.4377-.7581.6052-2.5841-1.3501-5.6222zm-13.1249-14.13c-1.4266-.5606-2.8332-1.0073-4.1939-1.3388 1.6534-3.2124 3.3185-3.9804 4.1939-3.9804s2.5405.768 4.1939 3.9803c-1.3607.3316-2.7673.7783-4.1939 1.3389zm-5.4945 1.8783c.3282.0731.6612.1543.9984.2436-.2158.1193-.4314.2412-.6468.3655-.2153.1244-.4286.2502-.6398.3774.0912-.3367.1874-.6657.2882-.9865zm-3.4364-.4822c-3.6088-.1743-5.1064.8837-5.5441 1.6419-.4377.7581-.6052 2.5841 1.3501 5.6222.9675-1.0127 2.0577-2.0075 3.2565-2.9627.2278-1.5158.5442-2.9572.9375-4.3014zm-2.0581 9.999c.2274-.2477.4642-.4955.7102-.7429-.0046.2465-.0069.4942-.0069.7429s.0023.4964.0069.7429c-.246-.2474-.4828-.4952-.7102-.7429z"
      fill="#4888ee"
      fillRule="evenodd"
    />
    <ellipse cx="32.6908" cy="31.9999" fill="#4888ee" rx="2.57143" ry="2.57143" />
    <rect height="63" rx="31.5" stroke="#cbdaf2" width="63" x="1" y=".5" />
  </svg>
)

export const IconD = () => (
  <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    {' '}
    <rect x="15.3572" y="14.5251" width="8.57143" height="34.2857" rx="2" fill="#F7C1CA" />{' '}
    <rect x="15.3572" y="20.5251" width="8.57143" height="2.57143" fill="#D80027" />{' '}
    <rect x="15.3572" y="40.2395" width="8.57143" height="2.57143" fill="#D80027" />{' '}
    <rect x="26.5" y="14.5251" width="8.57143" height="34.2857" rx="2" fill="#F7C1CA" />{' '}
    <rect x="26.5" y="20.5251" width="8.57143" height="2.57143" fill="#D80027" />{' '}
    <rect x="26.5" y="40.2395" width="8.57143" height="2.57143" fill="#D80027" />{' '}
    <rect
      x="33.3523"
      y="16.2185"
      width="8.57143"
      height="34.2857"
      rx="2"
      transform="rotate(-15 33.3523 16.2185)"
      fill="#D80027"
    />{' '}
    <rect
      x="34.905"
      y="22.0139"
      width="8.57143"
      height="2.57143"
      transform="rotate(-15 34.905 22.0139)"
      fill="#F7C1CA"
    />{' '}
    <rect
      x="40.0076"
      y="41.0566"
      width="8.57143"
      height="2.57143"
      transform="rotate(-15 40.0076 41.0566)"
      fill="#F7C1CA"
    />{' '}
    <rect x="1" y="0.5" width="63" height="63" rx="31.5" stroke="#F7C1CA" />{' '}
  </svg>
)

export const IconSMC = () => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffb03f">
      <path d="m33.947 28.0142c1.0337-.6919 1.7143-1.8702 1.7143-3.2076 0-2.1302-1.7269-3.8571-3.8571-3.8571-2.1303 0-3.8572 1.7269-3.8572 3.8571 0 1.3374.6806 2.5157 1.7143 3.2076v17.3638c0 1.1835.9594 2.1429 2.1429 2.1429s2.1428-.9594 2.1428-2.1429z" />
      <path
        clipRule="evenodd"
        d="m20.119 19.9198c.454-1.1166.1335-2.4607-.9104-3.0634-1.0037-.5795-2.3001-.2562-2.7793.7991-2.1596 4.7547-2.0908 10.3238.1851 15.0243.5116 1.0565 1.8376 1.3403 2.8293.7122 1.0073-.6382 1.2806-1.9729.8041-3.066-1.4348-3.2915-1.4806-7.0816-.1288-10.4062z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m25.0774 22.7115c.2656-.5222.0782-1.1508-.5325-1.4326-.5872-.271-1.3455-.1198-1.6259.3737-1.2633 2.2236-1.2231 4.8281.1083 7.0263.2993.4941 1.075.6269 1.6551.3331.5893-.2985.7491-.9227.4704-1.4339-.8393-1.5393-.8662-3.3118-.0754-4.8666z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m44.0138 30.4084c-.454 1.1166-.1336 2.4607.9103 3.0634 1.0037.5794 2.3001.2561 2.7794-.7991 2.1595-4.7548 2.0908-10.3238-.1852-15.0243-.5115-1.0566-1.8376-1.3404-2.8292-.7122-1.0073.6382-1.2806 1.9729-.8041 3.066 1.4347 3.2914 1.4806 7.0816.1288 10.4062z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m39.0553 27.6167c-.2656.5222-.0782 1.1508.5325 1.4326.5872.271 1.3455.1198 1.6259-.3737 1.2633-2.2236 1.2231-4.8281-.1083-7.0264-.2992-.4941-1.075-.6268-1.6551-.333-.5893.2984-.7491.9226-.4704 1.4339.8393 1.5393.8662 3.3118.0754 4.8666z"
        fillRule="evenodd"
      />
    </g>
    <rect height="63" rx="31.5" stroke="#f7e899" width="63" x=".5" y=".5" />
  </svg>
)

export const IconS = () => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ff7439">
      <rect height="26.5714" rx="1.71428" width="3.42857" x="44.8572" y="18.2856" />
      <path
        clipRule="evenodd"
        d="m29.8573 44c3.077 0 5.5714-2.4944 5.5714-5.5714s-2.4944-5.5714-5.5714-5.5714-5.5714 2.4944-5.5714 5.5714 2.4944 5.5714 5.5714 5.5714zm0-2.5714c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3-1.6568 0-3 1.3432-3 3 0 1.6569 1.3432 3 3 3z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="m43.1429 20.8572-24 6.8571c0-.9468-.7675-1.7143-1.7143-1.7143-.9467 0-1.7142.7675-1.7142 1.7143v7.7143c0 .9468.7675 1.7143 1.7142 1.7143.9468 0 1.7143-.7675 1.7143-1.7143l24 6.8571z"
        fillRule="evenodd"
      />
    </g>
    <rect height="63" rx="31.5" stroke="#ffdbc9" width="63" x=".5" y=".5" />
  </svg>
)

export const IconA = () => (
  <svg fill="none" height="80" viewBox="0 0 80 80" width="80" xmlns="http://www.w3.org/2000/svg">
    <g fill="#44b600">
      <path
        clipRule="evenodd"
        d="m25 54.9999h1.6071c2.0711 0 3.75-1.6789 3.75-3.75 0-.8876-.7195-1.6071-1.6071-1.6071-2.0711 0-3.75 1.6789-3.75 3.75zm3.75-10.7143c-5.0298 0-9.1072 4.0775-9.1072 9.1072v6.5051c0 .2536.2056.4592.4592.4592h6.5051c5.0297 0 9.1071-4.0774 9.1071-9.1072 0-3.8462-3.118-6.9643-6.9642-6.9643z"
        fillRule="evenodd"
      />
      <path d="m43.2561 28.758c-.3709-.3492-.8612-.5436-1.3707-.5436h-15.7367c-.7113 0-1.3691.3778-1.7275.9922l-5.1667 8.8572c-.7777 1.3333.184 3.0077 1.7276 3.0077h15.9465c1.1045 0 2 .8954 2 2v15.9465c0 1.5436 1.6744 2.5053 3.0077 1.7276l8.8572-5.1667c.6144-.3584.9922-1.0162.9922-1.7276v-16.2014c0-.5514-.2277-1.0784-.6293-1.4564z" />
      <path
        clipRule="evenodd"
        d="m38.9287 50.7143v.9126c10.1227-4.9427 23.3116-11.8102 23.3116-23.6074v-5.9416c0-2.435-1.883-4.5779-4.4255-4.5779h-6.7547c-11.1037 0-17.653 13.4867-22.3394 23.5714h.5651c5.3256 0 9.6429 4.3173 9.6429 9.6429zm12.3213-20.3572c1.4793 0 2.6786-1.1992 2.6786-2.6785 0-1.4794-1.1993-2.6786-2.6786-2.6786s-2.6786 1.1992-2.6786 2.6786c0 1.4793 1.1993 2.6785 2.6786 2.6785z"
        fillRule="evenodd"
      />
    </g>
    <rect height="79" rx="39.5" stroke="#c9ebb5" width="79" x=".5" y=".5" />
  </svg>
)

export const Chevron = ({ className }: IconProps) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      clipRule="evenodd"
      d="m12 8-6.22843 6.3789c-.36209.3709-.36209.9721 0 1.343.36209.3708.94916.3708 1.31125 0l4.91718-5.036 4.9172 5.036c.3621.3708.9491.3708 1.3112 0 .3621-.3709.3621-.9721 0-1.343z"
      fill="#736e7d"
      fillRule="evenodd"
    />
  </svg>
)

export const CircledChevron = ({ className, onClick }: IconProps & { onClick?: () => void }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <rect x="1" y="1" width="24" height="24" rx="12" stroke="#CECECE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 13L13.7842 17.7911C14.0623 18.0696 14.5133 18.0696 14.7914 17.7911C15.0695 17.5126 15.0695 17.061 14.7914 16.7824L11.0144 13L14.7914 9.21755C15.0695 8.93902 15.0695 8.48743 14.7914 8.2089C14.5133 7.93037 14.0623 7.93037 13.7842 8.2089L9 13Z"
      fill="#242129"
    />
  </svg>
)

export const External = ({ white = false, black = false }: IconProps) => {
  const style = {
    verticalAlign: 'text-bottom',
    marginLeft: '4px',
  }

  let color = '#ff2d55'

  if (white) color = '#FFF'
  if (black) color = '#000'

  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g stroke={color} strokeLinecap="round" strokeLinejoin="round">
        <path d="m12 8.66667v4.00003c0 .3536-.1405.6927-.3905.9428-.2501.25-.5892.3905-.9428.3905h-7.33337c-.35362 0-.69276-.1405-.94281-.3905-.25004-.2501-.39052-.5892-.39052-.9428v-7.33337c0-.35362.14048-.69276.39052-.94281.25005-.25004.58919-.39052.94281-.39052h4" />
        <path d="m10 2h4v4" />
        <path d="m6.6665 9.33333 7.3333-7.33333" />
      </g>
    </svg>
  )
}

export const IconOk = () => {
  const style = { verticalAlign: 'text-bottom' }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={style}>
      <circle cx="12" cy="12" r="12" fill="#A5D6A7" />
      <path d="M16.6663 8.5L10.2497 14.9167L7.33301 12" stroke="#455453" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
